import React, { useEffect, useState } from 'react'
import './PopupTwoButtons.scss'

const PopupTwoButtons = (props) => {
    const { title, text, btnCancel, btnConfirm, clickClose, clickConfirm } = props

    const handleClickClose = () => {
        clickClose()
    }

    const handleClickConfirm = () => {
        clickConfirm()
    }

    return (
        <div className="popup-two-buttons-container">
            <div className="content">
                <div className="title">
                    <p>{title}</p>
                </div>
                <div className="text">
                    <p>{text}</p>
                </div>
                <div className="botton">
                    <button className="btn" onClick={handleClickConfirm}>{btnConfirm}</button>
                    <button className="btn" onClick={handleClickClose}>{btnCancel}</button>
                </div>
            </div>
        </div>
    )
}
export default PopupTwoButtons